// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Base mixins ─────────────────────────────────────── */
/* ─── Variantes ───────────────────────────────────────── */
.styles_form__jnWYG {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  width: 100%;
  background: var(--bg-white);
  border-color: var(--color-gray-400);
  color: var(--color-gray-800);
}
.styles_form__jnWYG i {
  font-size: 15px;
  line-height: 1;
}
.styles_form__jnWYG:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_form__jnWYG:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_form__jnWYG:not(:disabled):hover {
  border-color: var(--color-blue-primary);
  color: var(--color-blue-primary);
  background: var(--color-blue-light);
}

.styles_primary__wd-8i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: var(--color-gray-800);
  background: var(--bg-white);
  border-color: var(--bg-white);
  border-color: var(--color-gray-300);
}
.styles_primary__wd-8i i {
  font-size: 15px;
  line-height: 1;
}
.styles_primary__wd-8i:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_primary__wd-8i:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_primary__wd-8i:not(:disabled):hover {
  filter: brightness(0.88);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}
.styles_primary__wd-8i:not(:disabled):active {
  filter: brightness(0.82);
  transform: translateY(1px);
}
.styles_primary__wd-8i:not(:disabled):hover {
  background: var(--bg-gray);
  border-color: var(--color-gray-400);
  box-shadow: var(--shadow-sm);
}

.styles_btnBlue__O9RnB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: #fff;
  background: var(--color-blue-primary);
  border-color: var(--color-blue-primary);
}
.styles_btnBlue__O9RnB i {
  font-size: 15px;
  line-height: 1;
}
.styles_btnBlue__O9RnB:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_btnBlue__O9RnB:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_btnBlue__O9RnB:not(:disabled):hover {
  filter: brightness(0.88);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}
.styles_btnBlue__O9RnB:not(:disabled):active {
  filter: brightness(0.82);
  transform: translateY(1px);
}

.styles_btnRed__NZLyv {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: #fff;
  background: var(--color-red);
  border-color: var(--color-red);
}
.styles_btnRed__NZLyv i {
  font-size: 15px;
  line-height: 1;
}
.styles_btnRed__NZLyv:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_btnRed__NZLyv:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_btnRed__NZLyv:not(:disabled):hover {
  filter: brightness(0.88);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}
.styles_btnRed__NZLyv:not(:disabled):active {
  filter: brightness(0.82);
  transform: translateY(1px);
}

.styles_btngreen__VAemB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: #fff;
  background: var(--color-green);
  border-color: var(--color-green);
}
.styles_btngreen__VAemB i {
  font-size: 15px;
  line-height: 1;
}
.styles_btngreen__VAemB:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_btngreen__VAemB:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_btngreen__VAemB:not(:disabled):hover {
  filter: brightness(0.88);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}
.styles_btngreen__VAemB:not(:disabled):active {
  filter: brightness(0.82);
  transform: translateY(1px);
}

.styles_btnbluelight__fipEJ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: var(--color-blue-primary);
  background: var(--color-blue-light);
  border-color: var(--color-blue-light);
}
.styles_btnbluelight__fipEJ i {
  font-size: 15px;
  line-height: 1;
}
.styles_btnbluelight__fipEJ:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_btnbluelight__fipEJ:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_btnbluelight__fipEJ:not(:disabled):hover {
  filter: brightness(0.88);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}
.styles_btnbluelight__fipEJ:not(:disabled):active {
  filter: brightness(0.82);
  transform: translateY(1px);
}

.styles_btnBlack__B1mkh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: #fff;
  background: var(--color-gray-900);
  border-color: var(--color-gray-900);
}
.styles_btnBlack__B1mkh i {
  font-size: 15px;
  line-height: 1;
}
.styles_btnBlack__B1mkh:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_btnBlack__B1mkh:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_btnBlack__B1mkh:not(:disabled):hover {
  filter: brightness(0.88);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}
.styles_btnBlack__B1mkh:not(:disabled):active {
  filter: brightness(0.82);
  transform: translateY(1px);
}

.styles_transparent__t16mf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  background: transparent;
  border-color: transparent;
  color: var(--color-gray-600);
  padding: 0.4rem 0.5rem;
}
.styles_transparent__t16mf i {
  font-size: 15px;
  line-height: 1;
}
.styles_transparent__t16mf:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_transparent__t16mf:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_transparent__t16mf:not(:disabled):hover {
  background: var(--bg-gray-hover);
  color: var(--color-gray-900);
}

.styles_borderBack__LQP52 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: var(--color-gray-900);
  border-color: var(--color-gray-900);
  background: transparent;
}
.styles_borderBack__LQP52 i {
  font-size: 15px;
  line-height: 1;
}
.styles_borderBack__LQP52:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_borderBack__LQP52:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_borderBack__LQP52:not(:disabled):hover {
  background: rgba(0, 0, 0, 0.04);
}
.styles_borderBack__LQP52.styles_hover-green__7qlB6:not(:disabled):hover {
  color: var(--color-green);
  border-color: var(--color-green);
}
.styles_borderBack__LQP52.styles_hover-red__P8HqO:not(:disabled):hover {
  color: var(--color-red);
  border-color: var(--color-red);
}
.styles_borderBack__LQP52.styles_hover-blue__tjjI6:not(:disabled):hover {
  color: var(--color-blue);
  border-color: var(--color-blue);
}

.styles_bordergray__RRxWM {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: var(--color-gray-600);
  border-color: var(--color-gray-600);
  background: transparent;
}
.styles_bordergray__RRxWM i {
  font-size: 15px;
  line-height: 1;
}
.styles_bordergray__RRxWM:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_bordergray__RRxWM:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_bordergray__RRxWM:not(:disabled):hover {
  background: rgba(0, 0, 0, 0.04);
}
.styles_bordergray__RRxWM.styles_hover-green__7qlB6:not(:disabled):hover {
  color: var(--color-green);
  border-color: var(--color-green);
}
.styles_bordergray__RRxWM.styles_hover-red__P8HqO:not(:disabled):hover {
  color: var(--color-red);
  border-color: var(--color-red);
}
.styles_bordergray__RRxWM.styles_hover-blue__tjjI6:not(:disabled):hover {
  color: var(--color-blue);
  border-color: var(--color-blue);
}

.styles_borderBlue__0W4XB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0.45rem 1rem;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: var(--color-blue-primary);
  border-color: var(--color-blue-primary);
  background: transparent;
}
.styles_borderBlue__0W4XB i {
  font-size: 15px;
  line-height: 1;
}
.styles_borderBlue__0W4XB:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.styles_borderBlue__0W4XB:focus-visible {
  outline: 2px solid var(--color-blue-secondary);
  outline-offset: 2px;
}
.styles_borderBlue__0W4XB:not(:disabled):hover {
  background: rgba(0, 0, 0, 0.04);
}
.styles_borderBlue__0W4XB.styles_hover-green__7qlB6:not(:disabled):hover {
  color: var(--color-green);
  border-color: var(--color-green);
}
.styles_borderBlue__0W4XB.styles_hover-red__P8HqO:not(:disabled):hover {
  color: var(--color-red);
  border-color: var(--color-red);
}
.styles_borderBlue__0W4XB.styles_hover-blue__tjjI6:not(:disabled):hover {
  color: var(--color-blue);
  border-color: var(--color-blue);
}

.styles_btnSpinner__FiGWu {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: styles_btnSpin__TPGd6 0.55s linear infinite;
  flex-shrink: 0;
}

@keyframes styles_btnSpin__TPGd6 {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./../../shared/src/componets/ui/Button/styles.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,4DAAA;AAyEA,4DAAA;AAEA;EAxEI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EA2DA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,4BAAA;AAzDJ;AAHI;EAAI,eAAA;EAAiB,cAAA;AAOzB;AALI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAOR;AAJI;EACI,8CAAA;EACA,mBAAA;AAMR;AA8CI;EACI,uCAAA;EACA,gCAAA;EACA,mCAAA;AA5CR;;AAgDA;EAtFI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EAyCA,4BA+BkB;EA9BlB,2BA8ByC;EA7BzC,6BA6ByC;EACzC,mCAAA;AA5BJ;AA3CI;EAAI,eAAA;EAAiB,cAAA;AA+CzB;AA7CI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AA+CR;AA5CI;EACI,8CAAA;EACA,mBAAA;AA8CR;AAbI;EACI,wBAAA;EACA,yCAAA;AAeR;AAbI;EACI,wBAAA;EACA,0BAAA;AAeR;AAQI;EACI,0BAAA;EACA,mCAAA;EACA,4BAAA;AANR;;AAUA;EAhGI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EAyCA,WAyCkB;EAxClB,qCAwCwB;EAvCxB,uCAuCwB;AAU5B;AA1FI;EAAI,eAAA;EAAiB,cAAA;AA8FzB;AA5FI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AA8FR;AA3FI;EACI,8CAAA;EACA,mBAAA;AA6FR;AA5DI;EACI,wBAAA;EACA,yCAAA;AA8DR;AA5DI;EACI,wBAAA;EACA,0BAAA;AA8DR;;AA5BA;EApGI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EAyCA,WA6CkB;EA5ClB,4BA4CwB;EA3CxB,8BA2CwB;AAgD5B;AApII;EAAI,eAAA;EAAiB,cAAA;AAwIzB;AAtII;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAwIR;AArII;EACI,8CAAA;EACA,mBAAA;AAuIR;AAtGI;EACI,wBAAA;EACA,yCAAA;AAwGR;AAtGI;EACI,wBAAA;EACA,0BAAA;AAwGR;;AAlEA;EAxGI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EAyCA,WAiDkB;EAhDlB,8BAgDwB;EA/CxB,gCA+CwB;AAsF5B;AA9KI;EAAI,eAAA;EAAiB,cAAA;AAkLzB;AAhLI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAkLR;AA/KI;EACI,8CAAA;EACA,mBAAA;AAiLR;AAhJI;EACI,wBAAA;EACA,yCAAA;AAkJR;AAhJI;EACI,wBAAA;EACA,0BAAA;AAkJR;;AAxGA;EA5GI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EAyCA,gCAqDkB;EApDlB,mCAoD6C;EAnD7C,qCAmD6C;AA4HjD;AAxNI;EAAI,eAAA;EAAiB,cAAA;AA4NzB;AA1NI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AA4NR;AAzNI;EACI,8CAAA;EACA,mBAAA;AA2NR;AA1LI;EACI,wBAAA;EACA,yCAAA;AA4LR;AA1LI;EACI,wBAAA;EACA,0BAAA;AA4LR;;AA9IA;EAhHI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EAyCA,WAyDkB;EAxDlB,iCAwDwB;EAvDxB,mCAuDwB;AAkK5B;AAlQI;EAAI,eAAA;EAAiB,cAAA;AAsQzB;AApQI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAsQR;AAnQI;EACI,8CAAA;EACA,mBAAA;AAqQR;AApOI;EACI,wBAAA;EACA,yCAAA;AAsOR;AApOI;EACI,wBAAA;EACA,0BAAA;AAsOR;;AApLA;EApHI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EAuGA,uBAAA;EACA,yBAAA;EACA,4BAAA;EACA,sBAAA;AAqMJ;AA7SI;EAAI,eAAA;EAAiB,cAAA;AAiTzB;AA/SI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAiTR;AA9SI;EACI,8CAAA;EACA,mBAAA;AAgTR;AAhNI;EACI,gCAAA;EACA,4BAAA;AAkNR;;AA9MA;EAjII,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EA0BA,4BAyFmB;EAxFnB,mCAwFmB;EAvFnB,uBAAA;AAyTJ;AAnVI;EAAI,eAAA;EAAiB,cAAA;AAuVzB;AArVI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAuVR;AApVI;EACI,8CAAA;EACA,mBAAA;AAsVR;AApUI;EACI,+BAAA;AAsUR;AAnUI;EAAuC,yBAAA;EAA2B,gCAAA;AAuUtE;AAtUI;EAAuC,uBAAA;EAA2B,8BAAA;AA0UtE;AAzUI;EAAuC,wBAAA;EAA2B,+BAAA;AA6UtE;;AA3PA;EArII,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EA0BA,4BA6FmB;EA5FnB,mCA4FmB;EA3FnB,uBAAA;AA0WJ;AApYI;EAAI,eAAA;EAAiB,cAAA;AAwYzB;AAtYI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAwYR;AArYI;EACI,8CAAA;EACA,mBAAA;AAuYR;AArXI;EACI,+BAAA;AAuXR;AApXI;EAAuC,yBAAA;EAA2B,gCAAA;AAwXtE;AAvXI;EAAuC,uBAAA;EAA2B,8BAAA;AA2XtE;AA1XI;EAAuC,wBAAA;EAA2B,+BAAA;AA8XtE;;AAxSA;EAzII,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,uHAAA;EAEA,mBAAA;EACA,sBAAA;EA0BA,gCAiGmB;EAhGnB,uCAgGmB;EA/FnB,uBAAA;AA2ZJ;AArbI;EAAI,eAAA;EAAiB,cAAA;AAybzB;AAvbI;EACI,mBAAA;EACA,aAAA;EACA,oBAAA;AAybR;AAtbI;EACI,8CAAA;EACA,mBAAA;AAwbR;AAtaI;EACI,+BAAA;AAwaR;AAraI;EAAuC,yBAAA;EAA2B,gCAAA;AAyatE;AAxaI;EAAuC,uBAAA;EAA2B,8BAAA;AA4atE;AA3aI;EAAuC,wBAAA;EAA2B,+BAAA;AA+atE;;AArVA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;EACA,sDAAA;EACA,cAAA;AAwVJ;;AArVA;EACI;IAAK,yBAAA;EAyVP;AACF","sourcesContent":["/* ─── Base mixins ─────────────────────────────────────── */\n\n@mixin btn-base {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 0.45rem 1rem;\n    border-radius: 4px;\n    font-size: 15px;\n    font-weight: 500;\n    font-family: inherit;\n    line-height: 1.4;\n    border: 1.5px solid transparent;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease,\n                color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n    white-space: nowrap;\n    letter-spacing: 0.01em;\n\n    i { font-size: 15px; line-height: 1; }\n\n    &:disabled {\n        cursor: not-allowed;\n        opacity: 0.45;\n        pointer-events: none;\n    }\n\n    &:focus-visible {\n        outline: 2px solid var(--color-blue-secondary);\n        outline-offset: 2px;\n    }\n}\n\n@mixin hoverBtn($color) {\n    transition: all ease-in .2s;\n    &:not(:disabled):hover {\n        color: $color;\n        border-color: $color;\n    }\n}\n\n@mixin borderBtn($color) {\n    @include btn-base;\n    color: $color;\n    border-color: $color;\n    background: transparent;\n\n    &:not(:disabled):hover {\n        background: rgba(0,0,0,0.04);\n    }\n\n    &.hover-green:not(:disabled):hover   { color: var(--color-green); border-color: var(--color-green); }\n    &.hover-red:not(:disabled):hover     { color: var(--color-red);   border-color: var(--color-red); }\n    &.hover-blue:not(:disabled):hover    { color: var(--color-blue);  border-color: var(--color-blue); }\n}\n\n@mixin colorBtn($color, $bg) {\n    @include btn-base;\n    color: $color;\n    background: $bg;\n    border-color: $bg;\n\n    &:not(:disabled):hover {\n        filter: brightness(0.88);\n        box-shadow: 0 2px 8px rgba(0,0,0,0.14);\n    }\n    &:not(:disabled):active {\n        filter: brightness(0.82);\n        transform: translateY(1px);\n    }\n}\n\n/* ─── Variantes ───────────────────────────────────────── */\n\n.form {\n    @include btn-base;\n    width: 100%;\n    background: var(--bg-white);\n    border-color: var(--color-gray-400);\n    color: var(--color-gray-800);\n\n    &:not(:disabled):hover {\n        border-color: var(--color-blue-primary);\n        color: var(--color-blue-primary);\n        background: var(--color-blue-light);\n    }\n}\n\n.primary {\n    @include colorBtn(var(--color-gray-800), var(--bg-white));\n    border-color: var(--color-gray-300);\n    &:not(:disabled):hover {\n        background: var(--bg-gray);\n        border-color: var(--color-gray-400);\n        box-shadow: var(--shadow-sm);\n    }\n}\n\n.btnBlue {\n    @include colorBtn(#fff, var(--color-blue-primary));\n}\n\n.btnRed {\n    @include colorBtn(#fff, var(--color-red));\n}\n\n.btngreen {\n    @include colorBtn(#fff, var(--color-green));\n}\n\n.btnbluelight {\n    @include colorBtn(var(--color-blue-primary), var(--color-blue-light));\n}\n\n.btnBlack {\n    @include colorBtn(#fff, var(--color-gray-900));\n}\n\n.transparent {\n    @include btn-base;\n    background: transparent;\n    border-color: transparent;\n    color: var(--color-gray-600);\n    padding: 0.4rem 0.5rem;\n\n    &:not(:disabled):hover {\n        background: var(--bg-gray-hover);\n        color: var(--color-gray-900);\n    }\n}\n\n.borderBack {\n    @include borderBtn(var(--color-gray-900));\n}\n\n.bordergray {\n    @include borderBtn(var(--color-gray-600));\n}\n\n.borderBlue {\n    @include borderBtn(var(--color-blue-primary));\n}\n\n.btnSpinner {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border: 2px solid currentColor;\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: btnSpin 0.55s linear infinite;\n    flex-shrink: 0;\n}\n\n@keyframes btnSpin {\n    to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `styles_form__jnWYG`,
	"primary": `styles_primary__wd-8i`,
	"btnBlue": `styles_btnBlue__O9RnB`,
	"btnRed": `styles_btnRed__NZLyv`,
	"btngreen": `styles_btngreen__VAemB`,
	"btnbluelight": `styles_btnbluelight__fipEJ`,
	"btnBlack": `styles_btnBlack__B1mkh`,
	"transparent": `styles_transparent__t16mf`,
	"borderBack": `styles_borderBack__LQP52`,
	"hover-green": `styles_hover-green__7qlB6`,
	"hover-red": `styles_hover-red__P8HqO`,
	"hover-blue": `styles_hover-blue__tjjI6`,
	"bordergray": `styles_bordergray__RRxWM`,
	"borderBlue": `styles_borderBlue__0W4XB`,
	"btnSpinner": `styles_btnSpinner__FiGWu`,
	"btnSpin": `styles_btnSpin__TPGd6`
};
export default ___CSS_LOADER_EXPORT___;
